import { equalsTo, isEmail, isEmpty } from './Validator';

const Required = (value: any): string | undefined => (isEmpty(value) ? 'Required' : undefined);

const IsEmail = (value: any): string | undefined =>
  !isEmail(value) ? 'Enter email in this format: example@mail.com' : undefined;

const IsEqualTo = (
  firstValue: any,
  secondValue: any,
  errorText = 'Not equal values'
): string | undefined => (!equalsTo(firstValue, secondValue) ? errorText : undefined);

const composeValidators =
  (...validators: any[]): any =>
  (value: any): any =>
    validators.reduce((error, validator) => error || validator(value), undefined);

export { Required, IsEmail, IsEqualTo, composeValidators };
